import { Injectable } from '@angular/core';
import { Platform, normalizeURL, ActionSheetController } from 'ionic-angular';
import { UploadFS } from 'meteor/jalik:ufs';
import { PicturesStore } from 'api/collections';
import * as _ from 'lodash';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Crop } from '@ionic-native/crop';
import { File as IonicFile, Entry, FileEntry } from '@ionic-native/file';
import { HttpService } from './httpService';

@Injectable()
export class PictureService {
  constructor(
    private platform: Platform,
    private camera: Camera,
    private crop: Crop,
    private file: IonicFile,
    private httpService: HttpService
  ) {
  }

  getPicture(actionSheetCtrl: ActionSheetController): Promise<Blob> {
    if (!this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        try {
          UploadFS.selectFile((file: Blob) => {
            resolve(file);
          });
        } catch (e) {
          reject(e);
        }
      });
    }

    return new Promise((resolve, reject) => {
      let actionSheet = actionSheetCtrl.create({
        title: 'Add a Photo',
        buttons: [
          {
            text: 'Take photo...',
            icon: 'camera',
            handler: () => {
              resolve(true);
            }
          },{
            text: 'Choose from Library...',
            icon: 'image',
            handler: () => {
              resolve(false);
            }
          },{
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              reject();
            }
          }
        ]
      });
      actionSheet.present();
    }).then((useCamera) => {
      return this.camera.getPicture(<CameraOptions>{
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        quality: 50,
        correctOrientation: true,
        // saveToPhotoAlbum: false,
        sourceType: useCamera ? 1 : 0
      }).then((imageData) => {
        // let base64Image = 'data:image/jpeg;base64,' + imageData;
        return this.convertDataURIToBlob(imageData);
      });
    });

  }

  // upload(blob: Blob): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const metadata: any = _.pick(blob, 'name', 'type', 'size');

  //     if (!metadata.name) {
  //       metadata.name = 'LogItPhoto.jpg';
  //     }

  //     try {
  //       const upload = new UploadFS.Uploader({
  //         data: blob,
  //         adaptive: true,
  //         file: metadata,
  //         store: PicturesStore,
  //         onComplete: resolve,
  //         onError: reject,
  //         onAbort: reject,
  //         onStop: reject,
  //       });

  //       upload.start();
  //     } catch (e) {
  //       reject(e);
  //     }
  //   });
  // }

  async upload(blob: Blob): Promise<any> {
    console.log('uploading...')
    return new Promise(async (resolve, reject) => {
      try {
        const metadata: any = _.pick(blob, 'name', 'type', 'size');
        const postData = { metadata };
        const options = await this.httpService.getHttpOptions();
        const tempUrlRes: any = await this.httpService.postSls('/tempUrl', postData, options);
        const tempUrl = JSON.parse(tempUrlRes);
        if (tempUrl.isErr === false) {
          const { s3Credentials, filePath } = tempUrl.data;
          const { type } = metadata;
          const uploadRes = await this.httpService.uploadS3File(s3Credentials, filePath, type, blob);
          console.log('S3 upload complete');
          const uploadedFile = s3Credentials.split('?')[0];
          const res = {
            status: 200,
            url: uploadedFile
          };
          resolve(res);
        } else {
          console.log('error in temp url POST', tempUrl)
          reject(null);
        }
      } catch (err) {
        console.log('error: upload s3 to presigned url:', err);
        reject(err);
      }
    })
  }

  convertDataURIToBlob(dataURI): Blob {
    const binary = atob(dataURI);

    // Write the bytes of the string to a typed array
    const charCodes = Object.keys(binary)
      .map<number>(Number)
      .map<number>(binary.charCodeAt.bind(binary));

    // Build blob with typed array
    return new Blob([new Uint8Array(charCodes)], {type: 'image/jpeg'});
  }
}



// WEBPACK FOOTER //
// ./src/services/picture.ts